module.exports = __webpack_public_path__ + "static/media/logo.f78c6cc4.png";